// import axios, {AxiosRequestConfig} from 'axios'
// import * as authHelper from 'src/app/modules/auth/core/AuthHelpers'

// /**
//  * API Urls
//  */
// interface APIUrls {
//   Services: {
//     Department: string
//     Position: string
//     User: string
//     CurrentUser: string
//     Access : string
//     Profile : string
//     ProfileDetail : string
//   }
//   Admin: {
//     Department: string
//     Position: string
//     User: string
//     UserAccount: string
//     CurrentUser: string
//   }
//   Authentication: {
//     Authenticate: string
//     RevokeToken: string
//     RefreshToken: string
//   }
//   Core: {
//     UserAccount: string
//   }
//   Design: {
//     RecProfiles: string
//     FieldsLookup: string
//     MstDataLookup: string
//   }
//   Record: {
//     RecProfiles: string
//   }
//   Library:{
//     lib:string
//   }
// }

// export const API_URL = process.env.REACT_APP_API_URL

// export const APIUrls: APIUrls = {
//   Services: {
//     Position: `${API_URL}/position-service/positions`,
//     Department: `${API_URL}/department-service/departments`,
//     User: `${API_URL}/user-service/users`,
//     CurrentUser: `${API_URL}/user-service/current-user`,
//     Access: `${API_URL}/permission-service/permission-groups`,
//     Profile:`${API_URL}/profile-service/profiles`,
//     ProfileDetail:`${API_URL}/profile-service/profiledetails`
//   },
//   Admin: {
//     Department: `${API_URL}/admin/department`,
//     Position: `${API_URL}/admin/position`,
//     User: `${API_URL}/admin/user`,
//     UserAccount: `${API_URL}/admin/use-account`,
//     CurrentUser: `${API_URL}/admin/current-user`
//   },
//   Authentication: {
//     Authenticate: `${API_URL}/auth/authentication`,
//     RevokeToken: `${API_URL}/auth/revoke-token`,
//     RefreshToken: `${API_URL}/auth/refresh-token`,
//   },
//   Core: {
//     UserAccount: `${API_URL}/core/user-account`,
//   },
//   Design: {
//     RecProfiles: `${API_URL}/design/rec-profiles`,
//     FieldsLookup: `${API_URL}/design/fields-lookup`,
//     MstDataLookup: `${API_URL}/design/mst-data-lookup`,
//   },
//   Record: {
//     RecProfiles: `${API_URL}/record-profile-services/record-profiles`,
//   },
//   Library: {
//     lib:  `${API_URL}/library-service/libraries`,
//   }
// }

// /**
//  * API Config
//  */
// export function setCommonHeaders(): AxiosRequestConfig {
//   const auth = authHelper.getAuth()
//   return {
//     headers: {
//       Authorization: `Basic ${auth!.accessToken}`,
//     },
//   }
// }

// export const Headers = setCommonHeaders()

// const axiosInstance = require('axios')
// const auth = authHelper.getAuth()
// export let ebitaFetcher = axiosInstance.create({
//    baseURL: API_URL,
//   headers: {
//     Authorization: `Basic ${auth!.accessToken}`,
//   },
// })


import axios, { AxiosRequestConfig, AxiosInstance } from 'axios'
import * as authHelper from 'src/app/modules/auth/core/AuthHelpers'

/**
 * API Urls
 */
interface APIUrls {
  Services: {
    Department: string
    Position: string
    User: string
    CurrentUser: string
    Access: string
    Profile: string
    ProfileDetail: string
  }
  Admin: {
    Department: string
    Position: string
    User: string
    UserAccount: string
    CurrentUser: string
  }
  Authentication: {
    Authenticate: string
    RevokeToken: string
    RefreshToken: string
  }
  Core: {
    UserAccount: string
  }
  Design: {
    RecProfiles: string
    FieldsLookup: string
    MstDataLookup: string
  }
  Record: {
    RecProfiles: string
    TaggingLib:string
  }
  Library: {
    lib: string
    LibraryAccessPermissionListing:string
    LibraryAccessPermission:string

  }
  Document: {
    DocumentType: string
  }
  Process: {
    ProcessDesign: string,
    ProcessAccessPermission:string
    ProcessAccessPermissionUsers:string
    ProcessGroupName:string,
    CreateProcessPermission:string,
  },
  ProcessTask: {
    ProcessTask: string,
    taskslist: string,
  }
  Dashboard: {
    Summary: string
    DepartmentSummary: string
    LibrarySummary: string
  }

}

export const API_URL = (window as any).APP_CONFIG?.API_URL ?? process.env.REACT_APP_API_URL

export const APIUrls: APIUrls = {
  Services: {
    Position: `${API_URL}/position-service/positions`,
    Department: `${API_URL}/department-service/departments`,
    User: `${API_URL}/user-service/users`,
    CurrentUser: `${API_URL}/user-service/current-user`,
    Access: `${API_URL}/permission-service/permission-groups`,
    Profile: `${API_URL}/profile-service/profiles`,
    ProfileDetail: `${API_URL}/profile-service/profiledetails`
  },
  Admin: {
    Department: `${API_URL}/admin/department`,
    Position: `${API_URL}/admin/position`,
    User: `${API_URL}/admin/user`,
    UserAccount: `${API_URL}/admin/use-account`,
    CurrentUser: `${API_URL}/admin/current-user`
  },
  Authentication: {
    Authenticate: `${API_URL}/auth/authentication`,
    RevokeToken: `${API_URL}/auth/revoke-token`,
    RefreshToken: `${API_URL}/auth/refresh-token`,
  },
  Core: {
    UserAccount: `${API_URL}/core/user-account`,
  },
  Design: {
    RecProfiles: `${API_URL}/design/rec-profiles`,
    FieldsLookup: `${API_URL}/design/fields-lookup`,
    MstDataLookup: `${API_URL}/design/mst-data-lookup`,
  },
  Record: {
    RecProfiles: `${API_URL}/record-profile-services/record-profiles`,
    TaggingLib: `${API_URL}/process-design/record-profiles`,

  },
  Library: {
    lib: `${API_URL}/library-service/libraries`,
    LibraryAccessPermissionListing:`${API_URL}/library-access-permission-service/List`,
    LibraryAccessPermission:`${API_URL}/library-access-permission-service`,

  },
  Document: {
    DocumentType: `${API_URL}/document-types`,
  },
  Process: {
    ProcessDesign: `${API_URL}/process-design`,
    ProcessAccessPermission:`${API_URL}/process-access-permissions`,
    ProcessAccessPermissionUsers:`${API_URL}/process-access-permissions/users`,
    ProcessGroupName:`${API_URL}/process-access-permissions/process-designs`,
    CreateProcessPermission:`${API_URL}/process-access-permissions`,
  },
  ProcessTask: {
    ProcessTask: `${API_URL}/tasks`,
    taskslist: `${API_URL}/tasks`,
  },
  Dashboard: {
    Summary: `${API_URL}/dashboard/process-task/summary`, 
    DepartmentSummary: `${API_URL}/dashboard/staffs`,
    LibrarySummary:`${API_URL}/dashboard/libraries/summary`
  },
}


export function setCommonHeaders(): AxiosRequestConfig {
  const auth = authHelper.getAuth()
  return {
    headers: {
      Authorization: auth?.accessToken ? `Basic ${auth.accessToken}` : '',
    },
  }
}


export const Headers = setCommonHeaders()

export const ebitaFetcher: AxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Include cookies in requests
})

ebitaFetcher.interceptors.request.use(
  (config: any) => {
    const auth = authHelper.getAuth()
    console.log('Auth data:', auth ? 'Token exists' : 'No auth token found')
    console.log('Access Token:', auth?.accessToken ? `${auth.accessToken.substring(0, 20)}...` : 'None')
    
    if (auth && auth.accessToken) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Basic ${auth.accessToken}`
      console.log('Authorization header set:', config.headers.Authorization ? 'Yes' : 'No')
    } else {
      console.warn('No access token available for request')
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)


ebitaFetcher.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('401 Unauthorized - Session expired or invalid token')
      console.error('Request URL:', error.config?.url)
      // Clear auth storage
      authHelper.removeAuth()
      // Redirect to login page
      window.location.href = `${process.env.PUBLIC_URL}/auth`
    }
    return Promise.reject(error)
  }
)